import GLYPHS from './glyphs';

// Older markup still writes icons as classes: <i className="bi bi-check-circle" /> (Bootstrap
// Icons) or <i className="fas fa-heart" /> (Font Awesome). Neither icon font is loaded any more.
// installLegacyIconClasses() draws those same classes with ANNA's glyphs, so every icon in the
// app comes from glyphs.js. New code should use <Icon name="…" /> instead.
const LEGACY = {
  activity: ['bi-activity'],
  'alert-circle': ['bi-exclamation-circle'],
  'alert-triangle': ['bi-exclamation-triangle', 'bi-exclamation-triangle-fill', 'fa-exclamation-triangle'],
  'arrow-down': ['bi-arrow-down'],
  'arrow-left': ['bi-arrow-left'],
  'arrow-left-circle': ['bi-arrow-left-circle', 'bi-arrow-left-circle-fill'],
  'arrow-right': ['bi-arrow-right'],
  'arrow-up': ['bi-arrow-up'],
  'arrow-up-circle': ['bi-arrow-up-circle'],
  award: ['bi-award'],
  bolt: ['bi-lightning', 'fa-bolt'],
  book: ['bi-book', 'bi-journal-bookmark', 'bi-journal-text'],
  bookmark: ['bi-bookmark'],
  brain: ['fa-brain'],
  briefcase: ['fa-briefcase'],
  building: ['bi-building', 'bi-building-fill'],
  calendar: ['bi-calendar3', 'bi-calendar-date', 'fa-calendar-alt'],
  'calendar-check': ['bi-calendar-check'],
  'calendar-event': ['bi-calendar-event'],
  'calendar-plus': ['bi-calendar-plus', 'fa-calendar-plus'],
  'calendar-range': ['bi-calendar-range'],
  'calendar-x': ['bi-calendar-x'],
  capslock: ['bi-capslock'],
  chat: ['bi-chat-dots'],
  'chat-text': ['bi-chat-left-text'],
  check: ['bi-check', 'bi-check-lg', 'fa-check'],
  'check-circle': ['bi-check-circle', 'bi-check-circle-fill', 'fa-check-circle'],
  'check-square': ['bi-check-square'],
  'chevron-left': ['bi-chevron-left'],
  'chevron-right': ['bi-chevron-right'],
  child: ['fa-child'],
  circle: ['bi-circle'],
  'clipboard-check': ['bi-clipboard-check', 'fa-clipboard-check'],
  clock: ['bi-clock', 'bi-clock-fill', 'fa-clock'],
  'cloud-upload': ['bi-cloud-upload', 'bi-cloud-arrow-up'],
  compass: ['bi-compass'],
  cursor: ['bi-cursor-fill'],
  dashboard: ['fa-tachometer-alt'],
  download: ['bi-download'],
  edit: ['bi-pencil-square'],
  eye: ['bi-eye', 'fa-eye'],
  'eye-off': ['bi-eye-slash', 'fa-eye-slash'],
  'file-check': ['bi-file-check'],
  'file-spreadsheet': ['bi-file-earmark-excel', 'bi-file-earmark-spreadsheet'],
  'file-upload': ['bi-file-earmark-arrow-up'],
  filter: ['bi-funnel', 'fa-filter'],
  flower: ['bi-flower1'],
  folder: ['fa-folder'],
  'folder-open': ['bi-folder2-open'],
  gender: ['bi-gender-ambiguous', 'fa-venus-mars'],
  'graduation-cap': ['bi-mortarboard', 'bi-mortarboard-fill', 'fa-graduation-cap'],
  grid: ['bi-grid', 'bi-grid-3x2-gap', 'bi-grid-3x3-gap'],
  hash: ['bi-hash', 'bi-123'],
  heart: ['fa-heart'],
  'heart-pulse': ['fa-heart-pulse'],
  hierarchy: ['bi-diagram-2', 'bi-diagram-3'],
  history: ['bi-clock-history'],
  home: ['bi-house'],
  hourglass: ['bi-hourglass-split'],
  'id-card': ['bi-person-badge', 'bi-card-text'],
  info: ['bi-info-circle', 'bi-info-circle-fill', 'fa-info-circle', 'fa-info'],
  key: ['bi-key', 'bi-key-fill'],
  layers: ['bi-layers', 'bi-collection'],
  lightbulb: ['bi-lightbulb', 'fa-lightbulb'],
  'line-chart': ['bi-graph-up'],
  list: ['bi-list-ul', 'fa-list'],
  'list-check': ['bi-list-check'],
  lock: ['bi-lock', 'bi-lock-fill', 'fa-lock'],
  mail: ['bi-envelope', 'fa-envelope'],
  'mail-check': ['bi-envelope-check'],
  menu: ['bi-list'],
  'minus-circle': ['bi-dash-circle'],
  'more-vertical': ['bi-three-dots-vertical'],
  'pause-circle': ['bi-pause-circle'],
  pencil: ['bi-pencil'],
  phone: ['bi-telephone'],
  play: ['bi-play-fill'],
  'play-circle': ['bi-play-circle'],
  plus: ['bi-plus-lg'],
  'plus-circle': ['bi-plus-circle', 'fa-plus-circle'],
  puzzle: ['bi-puzzle'],
  refresh: ['bi-arrow-clockwise'],
  save: ['bi-save', 'bi-save2'],
  search: ['bi-search', 'fa-search'],
  send: ['bi-send'],
  settings: ['bi-gear', 'bi-gear-fill'],
  shield: [],
  'shield-check': ['bi-shield-check'],
  'shield-lock': ['bi-shield-lock-fill'],
  'sign-in': ['bi-box-arrow-in-right'],
  sliders: ['bi-sliders'],
  smile: ['bi-emoji-smile'],
  sort: ['bi-arrow-down-up'],
  sparkles: ['bi-magic'],
  star: ['bi-star'],
  stopwatch: ['bi-stopwatch'],
  sync: ['bi-arrow-repeat'],
  table: ['bi-table'],
  tag: ['bi-tag', 'bi-tags', 'fa-tags'],
  'text-left': ['bi-text-left'],
  trash: ['bi-trash'],
  upload: ['bi-upload'],
  user: ['bi-person', 'fa-user'],
  'user-circle': ['bi-person-circle'],
  'user-plus': ['bi-person-plus'],
  'user-x': ['bi-person-x', 'bi-person-x-fill'],
  users: ['bi-people', 'bi-people-fill'],
  'wifi-off': ['bi-wifi-off'],
  x: ['bi-x', 'bi-x-lg'],
  'x-circle': ['bi-x-circle', 'bi-x-circle-fill', 'bi-x-octagon'],
};

const toMaskUrl = (markup) => {
  const inner = markup
    .replace(/class="d"/g, 'fill="#000" fill-opacity=".16" stroke="none"')
    .replace(/class="f"/g, 'fill="#000" stroke="none"');
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

export const legacyIconCss = () => Object.entries(LEGACY)
  .filter(([, classes]) => classes.length)
  .map(([glyph, classes]) => `${classes.map((c) => `.${c}`).join(',')}{--ic:${toMaskUrl(GLYPHS[glyph])}}`)
  .join('\n');

/** Adds the class-to-glyph rules once. Call before the app renders. */
export const installLegacyIconClasses = () => {
  if (typeof document === 'undefined' || document.getElementById('anna-legacy-icons')) return;
  const style = document.createElement('style');
  style.id = 'anna-legacy-icons';
  style.textContent = legacyIconCss();
  document.head.appendChild(style);
};

export default LEGACY;
